import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"Exo", "Helvetica", "Arial", sans-serif',
      },
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: false, // pozwala na pełną kontrolę
            },
           
        },
    },
    palette: {
        primary: {
            main: '#1C353A', // navy
        },
        secondary: {
            main: '#E84055', // red
        },
        turquoise: {
            main: '#72A3A8',
            dark: '#4A6B6F',
        },
        bgLight: {
            main: '#E0EAF1',
        },
    },
});

export default theme;